/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_color.svg'
import {COLORTEXTO, SECCIONES} from "../../Constantes";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useNavigate} from "react-router-dom";
import Boton from "../Secciones/Componentes/SubComponentes/Boton";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Espacio from "../Dialogos/Dialogo_Espacio";
import {espacios} from "../Secciones/Componentes/Home_Espacios";


const BarraPc = () => {
    const {ir, Aviso, abrirAviso} = useIrRuta()
    const navigate = useNavigate();
    const {Dialogo, cerrar, abrir} = useDialogo({Componente: Dialogo_Espacio, titulo: 'Regisitro'})



    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Aviso/>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={180} height={'auto'} alt={"logo"} onClick={() => navigate('/Home')}
                                 style={{cursor: 'pointer'}}
                            />
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', px: 8}}>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{px: 6}}
                            >


                                {SECCIONES.map((item, index) => (
                                    <Typography
                                        onClick={() => ir(item)}
                                        sx={{
                                            fontWeight: 600,
                                            color: COLORTEXTO,
                                            cursor: 'pointer',
                                            borderBottom: 2,
                                            borderColor: '#00000000',
                                            transition: "all .2s ease-in-out",
                                            '&:hover': {
                                                borderColor: '#000',
                                            }
                                        }}>{item}</Typography>
                                ))}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                            <Grid
                                container
                                justifyContent={'flex-end'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >


                                <Boton
                                    habilitado={true}
                                    click={() => ir('espacios')}
                                    texto={'Ver Espacios'}/>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraPc



